import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { fetchLeads } from "../services/api";

export const getLeads = createAsyncThunk("leads/fetchLeads", async ({ page, type }) => {
  console.log(page, type);
  await new Promise((resolve) => setTimeout(resolve, 2000));
  const response = await fetchLeads({ page, type });
  return response;
});

const leadsSlice = createSlice({
  name: "leads",
  initialState: { data: [], status: "idle", currentType: null },
  extraReducers: (builder) => {
    builder
      .addCase(getLeads.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getLeads.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data = action.payload;
        state.currentType = action.meta.arg.type;
      })
      .addCase(getLeads.rejected, (state) => {
        state.status = "failed";
      });
  },
});

export default leadsSlice.reducer;
